// Components/Header.js — JCUMAS 060.013
import React from "react";

const Header = ({ subtitle = "Área de Gestión" }) => {
  const nombreUsuario = localStorage.getItem("nombreUsuario");

  return (
    <header className="mb-4" style={{ backgroundColor: "#ffffff", borderBottom: "1px solid var(--sp-border-strong)" }}>
      <nav className="navbar navbar-expand navbar-light px-3 justify-content-between">
        <div className="navbar-brand d-flex align-items-center mb-0">
          <span className="fw-bold text-primary">JCUMAS 060.013</span>
          <span className="text-muted ms-2">{subtitle}</span>
        </div>
        {nombreUsuario && (
          <span className="text-muted small">{nombreUsuario}</span>
        )}
      </nav>
    </header>
  );
};

export default Header;
